"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentInstanceDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const content_instance_json_1 = require("./content-instance-json");
exports.ContentInstanceDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('ContentModel', content_instance_json_1.ContentInstanceJsonMapper);
